<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('default.add')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="add">

                <loading slot="waiting"/>

                <form @submit.prevent="validate_add">

                    <!-- Name -->
                    <div class="form-group">

                        <label for="name">{{ $t('simple.name') }}</label>

                        <input
                            class="form-control"
                            type="text"
                            id="name"
                            name="name"
                            v-validate="'required|max:15'"
                            v-model="name"
                        >

                        <small v-show="errors.has('name')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('name') }}</small>

                    </div>

                    <!-- Description -->
                    <div class="form-group">

                        <label for="description">{{ $t('simple.desc') }}</label>

                        <input 
                            class="form-control"
                            type="text"
                            id="description"
                            name="description"
                            v-validate="'required|max:50'"
                            v-model="description"
                        >

                        <small v-show="errors.has('description')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('description') }}</small>

                    </div>

                    <!-- Content -->
                    <div class="form-group">

                        <label for="content">{{ $t('simple.content') }}</label>

                        <b-form-textarea
                            :rows="3"
                            :max-rows="6"
                            id="content"
                            name="content"
                            v-validate="'required|max:250'"
                            v-model="content">
                        </b-form-textarea>


                        <small v-show="errors.has('content')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('content') }}</small>

                    </div>


                    <div class="form-group">

                        <label for="status">{{ $t('simple.status') }}</label>

                        <b-form-checkbox v-model="status">
                          {{ check_status() }}
                        </b-form-checkbox>

                    </div>

                </form>

            </v-wait>

        </div>

        <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>

            <b-button @click="validate_add()" variant="primary">{{ $t('simple.save') }}</b-button>
            
        </div>


        </div>
      </div>
    </div>
</template>
<script>


    export default {

        mounted: function () {
            // Component mounted
            console.log('Announcement Add Modal mounted');
        },
        
        destroyed() {
            // Component destroyed
            console.log('Announcement Add Modal destroyed.');
        },

        data: function() {
            return  {
                announcements_api: '/api/v1/settings/announcements/',
                name: '',
                description: '',
                content: '',
                status: false,
            }
        },

        methods: {
            announcement_add: async function(){

                // Loading start
                this.$wait.start('add');

                // Post request
                await axios.post(this.announcements_api, {
                    name: this.name,
                    description: this.description,
                    content: this.content,
                    status: this.status,
                  })
                  .then((response) => {

                    // Loading end
                    this.$wait.end('add');

                    // Show success
                    Vue.toasted.success(this.$t('simple.success_info'));

                    // Close modal
                    this.$close(true);

                  })
                  .catch((error) => {

                    // Loading end
                    this.$wait.end('add');

                    // Show error
                    Vue.toasted.error(this.$t('simple.error_info'));

                    // Close modal
                    //this.$close(true);

                  });

            },
            
            check_status: function() {
                if(this.status){
                    return this.$t('default.active');
                } else {
                    return this.$t('default.inactive');
                }
            },

            validate_add: async function() {
                // validate all fields
                await this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Send it to account edit function
                        this.announcement_add();
                    }
                });
            },
        },
    }
</script>